import Audio from "./Audio";

const audio = new Audio();
audio.load();
export default audio;
